export default {
    'name': 'literature',
    'label': 'patent-view.Literature',
    'getComponent': () => import('./Literature.vue'),
    'tabIndex': 10,
    'left': false,
    'right': false,
    'singleView': true,
    'exclusiveRoutePath': '/literature',
};
